import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  GetAllGroupVisitsGroupStatusEnum,
  GroupVisitControllerApi,
} from "@/services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  getXtenantId,
  useBaseContent,
} from "@/utils/utils";
import { GroupVisitListRow } from "@/pages/app/provider/group-visit";
import { useRef } from "react";

export const GROUP_VISIT_LIST_QUERY_KEY = "group-visit-list";

type Params = {
  pagination: DGT_Pagination;
  searchKey?: string;
  groupStatus?: GetAllGroupVisitsGroupStatusEnum;
  archive?: boolean;
  sortBy?: string;
  sortDirection?: string;
  enabled?: boolean;
};

/**
 * @author Rajkumar Rathod
 */
export const useGroupVisitList = ({
  pagination,
  searchKey,
  groupStatus,
  archive,
  sortBy,
  sortDirection,
  enabled = true,
}: Params): useBaseContent<GroupVisitListRow> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey,
    prevPage,
  });
  const pageSize = getPageSize(searchKey, pagination);

  return useQuery({
    queryKey: [
      GROUP_VISIT_LIST_QUERY_KEY,
      pageIndex,
      pageSize,
      searchKey,
      groupStatus,
      archive,
      sortBy,
      sortDirection,
    ],
    enabled,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new GroupVisitControllerApi(getConfigObject())
        .getAllGroupVisits(
          pageIndex, // page
          pageSize, // size
          sortBy, // sortBy
          sortDirection, // sortDirection
          searchKey ? searchKey : undefined, // searchString
          groupStatus, // groupStatus
          archive, // archive
          getXtenantId() // xTENANTID
        )
        .then((res) => res?.data),
  });
};
